// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {
  Banner,
  BannerBoldText,
  BannerFlexWrapper,
  BannerTextWrapper,
} from '../../../Banner';
import {CodeEditor} from '../../CodeEditor';

type ReadOnlyActionConfigProps = {
  actionConfig: string;
  actionTypeName: string;
};

export const ReadOnlyActionConfig = ({
  actionConfig,
  actionTypeName,
}: ReadOnlyActionConfigProps) => {
  const emptyConfig = actionConfig === '' || actionConfig === '{}';
  let isJsonError = false;
  if (!emptyConfig) {
    try {
      JSON.parse(actionConfig);
    } catch (e) {
      console.error(e);
      isJsonError = true;
    }
  }
  if (isJsonError) {
    return (
      <Banner variant="error">
        <BannerFlexWrapper>
          <Icon name="warning" />
          <BannerTextWrapper>Error parsing JSON</BannerTextWrapper>
        </BannerFlexWrapper>
      </Banner>
    );
  }
  if (emptyConfig) {
    return (
      <Banner variant="info">
        <BannerFlexWrapper>
          <Icon name="info" />
          <BannerTextWrapper>
            <BannerBoldText>No config available.</BannerBoldText>
            The user has not set up any specific configuration for this{' '}
            {actionTypeName}.
          </BannerTextWrapper>
        </BannerFlexWrapper>
      </Banner>
    );
  }
  return (
    <CodeEditor
      value={actionConfig}
      language="json"
      readOnly={true}
      maxHeight={300}
    />
  );
};
